import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; // Or use @highcharts/react components
import 'highcharts/modules/exporting';
import { Typography } from '@mui/material';

interface ChartProps {
  title: string;
  id: number;
  height: number;
}

const LowMarginLowVolume: React.FC<ChartProps> = ({ title, id, height = 345 }) => {
  const [categories, setCategories] = React.useState([]);
  const [currentGp, setCurrentGp] = React.useState([]);
  const [modelGp, setModelGp] = React.useState([]);
  const [currentPct, setCurrentPct] = React.useState([]);
  const [modelPct, setModelPct] = React.useState([]);
  const [totalSales, setTotalSales] = React.useState([]);
  
  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
  React.useEffect(() => {
    fetch(`/dashboard/low-margin-low-volume/${id}/?entity_id=${localStorage.getItem('entity_id')}`)
      .then(response => response.json())
      .then(data => 
        setTimeout(() => {
          setCategories(data.categories);
          setCurrentGp(data.current_gp);
          setModelGp(data.model_gp);
          setTotalSales(data.total_sales);
          setCurrentPct(data.current_pct);
          setModelPct(data.model_pct);
        }, 100)
      );

    const handleResize = () => {
      if (chartComponentRef.current && chartComponentRef.current.chart) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const options: Highcharts.Options = {
        chart: {
            type: 'column',
            zooming: {
                type: 'xy' as const
            }
        },
        title: {
            text: title,
            align: 'left'
        },
        
        xAxis: {
            crosshair: true,
            accessibility: {
                description: ''
            },
            title: {
                text: 'Products',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            // minRange: 10,
            categories: categories.length > 0 ? categories : [],
            labels: {
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },
        yAxis: {
            min: 0,
            max:100,
            title: {
                text: 'Volume (%)',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            labels: {
                formatter: function(this: Highcharts.AxisLabelsFormatterContextObject) {
                    return (this.value as number) + '%';
                },
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },
        tooltip: {
            valuePrefix: '$',
            formatter: function(this: Highcharts.Point) {
                const point = (this as any).point;
                const series = (this as any).series;
                const format = new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: 'USD',
                });
                return `<span style="text-align: center;font-family: Trebuchet MS;font-weight: bold;">${point.category || ''}</span><br/>` +
                `<span style="font-family: Trebuchet MS;">${series.name}: ${point.y.toFixed(2)}%</span><br/>`
            }
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            {
                type: 'column',
                name: 'Current',
                data: currentPct.length > 0 ? currentPct : [],
                dataLabels: {
                    formatter: function(this: Highcharts.Point) {
                        return (this.y as number).toFixed(2) + '%';
                    }
                }
            },
            {
                type: 'column',
                name: 'Opportunity',
                data: modelPct.length > 0 ? modelPct : [],
                dataLabels: {
                    formatter: function(this: Highcharts.Point) {
                        return (this.y as number).toFixed(2) + '%';
                    }
                }
            }
        ]
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
          {currentGp.length > 0 && modelGp.length > 0 ? (
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate={true}
                exportEnabled={true}
                ref={chartComponentRef}
                containerProps={{ style: { width: '100%', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
            />
          ) : (
            <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>No data available</Typography>
          )}
        </div>
    );
};

export default LowMarginLowVolume;
